export default __webpack_public_path__ + "static/media/80.6a1645a3.svg";